import React, { Component } from 'react';
import RainingLevelView from './RainingLevelView';
import { connect } from 'react-redux';
import * as tripActions from '../../../actions/tripActions';

class RainingLevelContainer extends Component {
  changeStep = (step, values) => {
    const { changeCurrentStep, saveTripData } = this.props;
    changeCurrentStep(step);
    saveTripData(values);
  };

  render() {
    return <RainingLevelView {...this.props} changeStep={this.changeStep} state={this.state} />;
  }
}

function mapStateToProps(state) {
  return {
    raining_level: state.tripReducer.tripForm.raining_level,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCurrentStep: step => dispatch(tripActions.changeCurrentStep(step)),
    saveTripData: data => dispatch(tripActions.saveTripData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RainingLevelContainer);
